import {
    Button,
    Flex,
    FormControl,
    FormLabel,
    GridItem,
    HStack,
    Input,
    SimpleGrid,
    Stack,
    Text,
    Textarea,
    useColorModeValue
} from "@chakra-ui/react";
import React, {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";

function BoatStatementForm({onSubmit, onBack, values}) {

    const ids = useMemo(() => ({
        versoes: "versoes",
        nome: "nome",
        rua: "rua",
        sentido: "sentido",
        faixa: "faixa",
        versao: "versao",
    }), []);

    const initFormData = (data) => {
        const initialFormData = {versoes: []};

        if (data) {
            for (const v of data) {
                initialFormData.versoes.push({
                    nome: v.nome,
                    rua: v.rua,
                    sentido: v.sentido,
                    faixa: v.faixa,
                    versao: v.versao,
                });
            }
        }

        return initialFormData;
    };

    const {t} = useTranslation();
    const textColor = useColorModeValue("gray.700", "white");
    const placeholderColor = useColorModeValue("gray.300", "gray.400");

    const [formData, setFormData] = useState(initFormData(values));

    const handleOnSubmit = () => {
        onSubmit(formData);
    }

    const saveDraft = () => {
        onSubmit(formData, true)
    }

    const addVersion = () => {
        formData.versoes.push(
            {
                nome: '',
                rua: '',
                sentido: '',
                faixa: '',
                versao: '',
            }
        );

        const newFormData = {...formData};
        setFormData(newFormData);
    }

    const removeVersion = (index) => {
        formData.versoes.splice(index, 1);

        const newFormData = {...formData};
        setFormData(newFormData);
    }

    const handleInputChange = (e) => {
        const idTokens = e.target.id.split("-");
        let value = e.target.value;

        const index = idTokens[1];
        const att = idTokens[2];

        formData.versoes[index][att] = value;

        const newFormData = {...formData};
        setFormData(newFormData);
    };

    return (
        <>
            <Button
                w="200px"
                variant="list-primary"
                fontSize="sm"
                onClick={addVersion}
            >
                {t('boat.actions.add-version')}
            </Button>

            <Stack>
                {formData?.versoes?.map((v, index) => (
                    <SimpleGrid key={`versions-${index}`} mt="10px">
                        <HStack>
                            <Text fontWeight="bold">{`${t('boat.new.version.title')} ${index + 1}`}</Text>
                            <Button variant="light" onClick={() => removeVersion(index)}>{t('system.actions.remove')}</Button>
                        </HStack>

                        <SimpleGrid spacing={2} columns={{sm: 1, md: 2}} mt="10px">
                            <FormControl>
                                <FormLabel color={textColor} fontWeight="bold" fontSize="xs">
                                    {t("boat.new.version.name")}
                                </FormLabel>
                                <Input
                                    fontSize="sm"
                                    variant="main"
                                    id={`${[ids.versoes]}-${index}-${[ids.nome]}`}
                                    value={v[ids.nome]}
                                    onChange={handleInputChange}
                                    placeholder={t("boat.new.version.name")}
                                    _placeholder={{color: placeholderColor}}
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel color={textColor} fontWeight="bold" fontSize="xs">
                                    {t("boat.new.version.street")}
                                </FormLabel>
                                <Input
                                    fontSize="sm"
                                    variant="main"
                                    id={`${[ids.versoes]}-${index}-${[ids.rua]}`}
                                    value={v[ids.rua]}
                                    onChange={handleInputChange}
                                    placeholder={t("boat.new.version.street")}
                                    _placeholder={{color: placeholderColor}}
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel color={textColor} fontWeight="bold" fontSize="xs">
                                    {t("boat.new.version.direction")}
                                </FormLabel>
                                <Input
                                    fontSize="sm"
                                    variant="main"
                                    id={`${[ids.versoes]}-${index}-${[ids.sentido]}`}
                                    value={v[ids.sentido]}
                                    onChange={handleInputChange}
                                    placeholder={t("boat.new.version.direction")}
                                    _placeholder={{color: placeholderColor}}
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel color={textColor} fontWeight="bold" fontSize="xs">
                                    {t("boat.new.version.crossing")}
                                </FormLabel>
                                <Input
                                    fontSize="sm"
                                    variant="main"
                                    id={`${[ids.versoes]}-${index}-${[ids.faixa]}`}
                                    value={v[ids.faixa]}
                                    onChange={handleInputChange}
                                    placeholder={t("boat.new.version.crossing")}
                                    _placeholder={{color: placeholderColor}}
                                />
                            </FormControl>

                            <GridItem colSpan={2}>
                                <FormControl>
                                    <FormLabel color={textColor} fontWeight="bold" fontSize="xs">
                                        {t("boat.new.version.title")}
                                    </FormLabel>
                                    <Textarea
                                        fontSize="sm"
                                        variant="main"
                                        id={`${[ids.versoes]}-${index}-${[ids.versao]}`}
                                        value={v[ids.versao]}
                                        onChange={handleInputChange}
                                        placeholder={t("boat.new.version.title")}
                                        _placeholder={{color: placeholderColor}}
                                    />
                                </FormControl>
                            </GridItem>

                        </SimpleGrid>
                    </SimpleGrid>
                ))}
            </Stack>

            <Flex w="100%" justify="space-between" mt="20px">
                <Button
                    variant="light"
                    fontSize="sm"
                    w="125px"
                    onClick={onBack}
                >
                    {t("system.actions.back")}
                </Button>
                <Flex>
                    <Button
                        w="150px"
                        variant="solid"
                        fontSize="sm"
                        mr="10px"
                        onClick={saveDraft}
                    >
                        {t('boat.actions.draft')}
                    </Button>
                    <Button
                        w="125px"
                        variant="dark"
                        fontSize="sm"
                        onClick={handleOnSubmit}
                    >
                        {t('system.actions.next')}
                    </Button>
                </Flex>
            </Flex>
        </>
    );
}

export default BoatStatementForm;